import { title } from 'assets/jss/material-kit-react.js'
import imagesStyle from 'assets/jss/material-kit-react/imagesStyles.js'
import { primaryColor } from 'assets/jss/material-kit-react'

const contactStyle = {
  section: {
    padding: '70px 0',
    textAlign: 'center',
  },
  title: {
    ...title,
    marginBottom: '1rem',
    marginTop: '30px',
    minHeight: '32px',
    textDecoration: 'none',
  },
  ...imagesStyle,
  itemGrid: {
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  itemFlex: {
    display: 'flex',
    flexDirection: 'columm',
    alignItems: 'center',
  },
  icons: {
    fontSize: '35px',
    display: 'inline-block',
    color: primaryColor,
    marginRight: '10px',
  },
  description: {
    color: '#999',
  },
  typo: {
    textAlign: 'left',
    fontSize: '20px',
    '@media (max-width: 830px)': {
      fontSize: '18px',
    },
    '@media (max-width: 576px)': {
      fontSize: '14px',
    },
  },
}

export default contactStyle
